import demoClient from '../services/http-client';
import { createModuleQueryKeys } from '../../createModuleQueryKeys';
import { useModuleQuery } from '../../useModuleQuery';

export const demoModuleKeys = {
  ...createModuleQueryKeys('demo-module'),
  data: (clientId: string | null) => [...demoModuleKeys.all(clientId), 'data'] as const,
};

/** GET / — demo payload from the module's upstream API. */
export const useDemoModuleDataQuery = () =>
  useModuleQuery({
    queryKey: demoModuleKeys.data,
    request: () => demoClient.get<any>('/'),
    staleTime: 0,
    refetchOnMount: 'always',
  });
